import { Sparkles } from 'lucide-react';

const COLOR = '#B47AEA';

/**
 * Lidé → Hodnocení. Záložka se teprve staví (`pripravovany` v katalogu),
 * do té doby jen ohlašuje, co přijde. Hlavičku nekreslí — nese ji modul.
 */
export default function Hodnoceni({ isDark }) {
    return (
        <div className="max-w-xl mx-auto text-center" style={{ padding: '48px 16px' }}>
            <div className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4"
                style={{ background: isDark ? `${COLOR}1f` : `${COLOR}14` }}>
                <Sparkles size={28} color={COLOR} />
            </div>
            <h3 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>Připravujeme</h3>
            <p className="text-sm max-w-sm mx-auto" style={{ color: 'var(--text-secondary)' }}>
                Hodnocení výkonu, KPI metriky a bonusové kalkulace — jako další záložka modulu Lidé.
            </p>
        </div>
    );
}
